export default __webpack_public_path__ + "static/media/link.501ba0ff.svg";